import { ListBulletIcon, Squares2X2Icon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import { SegmentedControl } from './segmented-control'
import type { ViewMode } from 'src/hooks/use-view-mode'

interface ViewModeToggleProps {
  value: ViewMode
  onChange: (mode: ViewMode) => void
  className?: string
}

export const ViewModeToggle = ({ value, onChange, className }: ViewModeToggleProps) => {
  const { t } = useTranslation()

  return (
    <SegmentedControl<ViewMode>
      aria-label={t('common.viewMode')}
      value={value}
      onChange={onChange}
      size="sm"
      className={className}
      data-testid="view-mode-toggle"
      options={[
        {
          value: 'list',
          label: (
            <span className="flex items-center">
              <ListBulletIcon className="h-4 w-4" aria-hidden="true" />
            </span>
          ),
          tooltip: t('common.listView'),
          'data-testid': 'view-mode-list',
        },
        {
          value: 'card',
          label: (
            <span className="flex items-center">
              <Squares2X2Icon className="h-4 w-4" aria-hidden="true" />
            </span>
          ),
          tooltip: t('common.cardView'),
          'data-testid': 'view-mode-card',
        },
      ]}
    />
  )
}
